import { Route } from '@angular/router'
import { authGuard, groupTypeGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type AppointmentsRoutes = {
    appointments: Route
}

export const appointmentsRoutes: AppointmentsRoutes = {
    appointments: {
        path: 'dashboard/appointments',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/appointments'],
            }),
            permissionGuard([PERMISSIONS.appointment.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./page-appointments/page-appointments.component').then(
                (m) => m.PageAppointmentsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
        children: [
            { path: '', redirectTo: 'scheduled', pathMatch: 'full' },
            {
                path: 'book',
                canActivate: [
                    permissionGuard([PERMISSIONS.appointment.write], {
                        redirectTo: ['/dashboard/appointments/scheduled'],
                    }),
                ],
                loadComponent: () =>
                    import('./page-book-appointment/page-book-appointment.component').then(
                        (m) => m.PageBookAppointmentComponent,
                    ),
            },
            {
                path: 'availability',
                canActivate: [
                    permissionGuard([PERMISSIONS.staff.read], {
                        redirectTo: ['/dashboard/appointments/scheduled'],
                    }),
                ],
                loadComponent: () =>
                    import('./page-available-schedule/page-available-schedule.component').then(
                        (m) => m.PageAvailableScheduleComponent,
                    ),
            },
            {
                path: 'scheduled',
                loadComponent: () =>
                    import('./page-scheduled-appointments/page-scheduled-appointments.component').then(
                        (m) => m.PageScheduledAppointmentsComponent,
                    ),
            },
        ],
    },
}
